//ドロワー開閉時間(CSSの設定と同一時間にする)
var drawerDuration = 500; //500 = 0.5s


// rollover
var preLoadImg = new Object();
 
function initRollOvers(){
  $("img.imgover,input.imgover").each(function(){
    var imgSrc = this.src;
    var sep = imgSrc.lastIndexOf('.');
    var onSrc = imgSrc.substr(0, sep) + '_o' + imgSrc.substr(sep, 4);
    preLoadImg[imgSrc] = new Image();
    preLoadImg[imgSrc].src = onSrc;
    $(this).hover(
      function() { this.src = onSrc; },
      function() { this.src = imgSrc; }
    );
  });
}
$(function(){
  initRollOvers();
});


// smoothScroll
var targetIdHold = jQuery(this.hash);

jQuery.easing.quart = function (x, t, b, c, d) {
  return -c * ((t = t / d - 1) * t * t * t - 1) + b;
};

jQuery(document).ready(function () {
  jQuery('a[href*="#"]').click(function () {
    let targetId = jQuery(this.hash);
    let scroll = $(window).scrollTop();

    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      let target = jQuery(this.hash);
      target = target.length && target || jQuery('[name=' + this.hash.slice(1) + ']');
      let headerH = $('#header').innerHeight();
      let adjust = 0; // ターゲット先へスクロール移動

      if (target.length) {
        let targetOffset = target.offset().top - headerH - adjust;

        jQuery('html,body').animate({
          scrollTop: targetOffset
        }, 1200, 'swing');

        // ターゲット先がスライドパネルの場合はオープン
        if (target.next(".js-slideBox").find(".js-slideBtn").hasClass('is-active')) {} else {
          target.next(".js-slideBox").find(".js-slideBtn").addClass('is-active');
          target.next(".js-slideBox").find(".js-slideBtn").next(".js-slidePanel").slideToggle(300);
        }

        return false;
      }
    }
  });
});

// 他ページからのsmoothScroll
$(function () {
  /* 現在のページURLの?anchor部分を取得
   * l-wrapにoverflow: hidden;を指定しているため、他ページからのアンカーリンクではハッシュタグを使用することができない。
   * そのため、「?anchor=id」という指定をすることで、ハッシュタグを使わずにアンカーリンクを実現する必要がある */
  let para = location.search;
  let headerH = $('#header').innerHeight();

  if (para.indexOf("?anchor=") != -1) {
    let anchor = para.split("?anchor=");
    let target = $('#' + anchor[anchor.length - 1]);

    setTimeout(function () {
      let position = target.offset().top - headerH;

      $("html, body").animate({
        scrollTop: position
      }, 1200, "swing");
    }, "1");
  }
});


// slide btn
$(function(){
  $(".js-slideBtn").each(function(index,element) {
    $(element).click(function() {
      $(this).toggleClass('is-active');
      $(element).next(".js-slidePanel").slideToggle(300);
    });
  });

  // ハッシュがあるときはオープン
  if (window.location.hash.length>0) {
    if ($(window.location.hash).next(".js-slideBox").find(".js-slideBtn").hasClass('is-active')) {
    } else {
      $(window.location.hash).next(".js-slideBox").find(".js-slideBtn").toggleClass('is-active');
      $(window.location.hash).next(".js-slideBox").find(".js-slideBtn").next(".js-slidePanel").slideToggle(300);
    }
  }
});


// header scroll settings
$(window).on('load scroll resize', function(){
  var headerPosTop = 30;  //ヘッダーの初期位置
  
  var winW = $(window).width();
  var winIW = window.innerWidth;  /* スクロールバーを含む幅 */
  var hd = $('#header');
  var contentTop = $('#hero');
  var gnav = $('#gnavfix');
  var logo = $('#js-hdlogo');
  var gnavBtns = $('#ganvBtn');
  var topblock = $('#topblock');
  var topblocklogo = $('#topblocklogo');
  var scroll = $(window).scrollTop();

  if ( scroll == 0 && winIW <= 767 ) {
    hd.removeClass('js-isscroll');
    hd.addClass('js-noscroll');
  } else if( scroll < headerPosTop && winIW > 767 ) {
    hd.removeClass('js-isscroll');
    hd.addClass('js-noscroll');
  } else if ( winIW > 767 ) {
    hd.removeClass('js-noscroll');
    hd.addClass('js-isscroll');
  } else {
    hd.removeClass('js-noscroll');
    hd.addClass('js-isscroll');
  }
  
  if ( scroll >= (topblocklogo.offset().top - topblock.offset().top) / 4 ) {
    topblock.attr('data-scroll', 'true');
  } else {
    topblock.attr('data-scroll', 'false');
  }
});


// ドロワー開閉
$(function(){
  var drawer_flag = $('body').attr('data-drawer');

  $("#drawerOpen").click(function () {
    drawer_flag = $('body').attr('data-drawer');
    $('body').attr('data-drawerprocessing', 'true'); //ドロワー処理中フラグを立てる

    if (drawer_flag == "init" || drawer_flag == "close") {
      $('body').attr('data-drawer', 'open');
      $('#drawer').attr('data-drawer', 'open');
      $('#gnav').attr('data-drawer', 'open');
      $('#drawerOpen').attr('data-drawer', 'open');
    } else {
      $('body').attr('data-drawer', 'close');
      $('#drawer').attr('data-drawer', 'close');
      $('#gnav').attr('data-drawer', 'close');
      $('#drawerOpen').attr('data-drawer', 'close');
    }

    drawerDuration = drawerDuration + 10; //ドロワーが開ききる直前に表示ががたつかないよう、処理時間を0.01s増やす

    setTimeout(function () {
      $('body').attr('data-drawerprocessing', 'false'); //ドロワー処理中フラグを下げる
    }, drawerDuration);
  });
});

$(window).on('resize', function(){
  let winIW = window.innerWidth;

  //PC時は、ドロワーはcloseにする
  if ( winIW >= 768 ) {
    $('body').attr('data-drawer', 'close');
    $('#drawer').attr('data-drawer', 'close');
    $('#gnav').attr('data-drawer', 'close');
    $('#drawerOpen').attr('data-drawer', 'close');
  }
});


//メニュークリック
$(function(){
  $(".js-gnavItem").each(function (index, element) {
    $(element).click(function () {
      if ($('body').attr('data-drawer') == 'open') {
        $('body').attr('data-drawer', 'close');
        $('#drawer').attr('data-drawer', 'close');
        $('#gnav').attr('data-drawer', 'close');
        $('#drawerOpen').attr('data-drawer', 'close');
      }
    });
  });
});


$(window).on('load scroll resize', function(){  
  let winW    = $(window).width();
  let winIW = window.innerWidth;   //スクロールバーを含む幅 
  let winIH = window.innerHeight;  //ウィンドウの高さ
  let bodyH = $('body').height(); //bodyタグの中身の高さ
  let scroll  = $(window).scrollTop();
  let fadeinitem  = $('.js-fadeinitem');
  let slideupitem  = $('.js-slideupitem');


  ///// 要素フェードイン /////
  fadeinitem.each(function(){
    let fiiTop = $(this).offset().top;

    // 要素が画面の上から80%(下から20%)に来た時に動く
    let fadeinitemPos = fiiTop - (winIH * 0.8);

    if (scroll > fadeinitemPos) {
      $(this).addClass("js-fadein");
    }
  });


  ///// 要素スライドアップ /////
  slideupitem.each(function(){
    let suiTop = $(this).offset().top;

    // 要素が画面の上から80%(下から20%)に来た時に動く
    let slideupitemPos = suiTop - (winIH * 0.8);

    if (scroll > slideupitemPos) {
      $(this).addClass("js-slideup");
    }
  });
});


$(window).on('load scroll resize', function(){  
  let winW    = $(window).width();
  let winIW = window.innerWidth;   //スクロールバーを含む幅 
  let winIH = window.innerHeight;  //ウィンドウの高さ
  let bodyH = $('body').height(); //bodyタグの中身の高さ
  let scroll  = $(window).scrollTop();
  
  
  // Contact Usがある場合
  if ( $('#contactus').length ) {
    let contactusScaleSpeed = 0.0015;
    let contactuswrapElem  = $('#contactuswrap');
    let contactusElem  = $('#contactus');

    ///// Contact Us縮小拡大 /////
    let contactusZoomSize = 1.5;
    let contactusTranslateY = 25; //25%パーセント
    let contactuswrapTop = contactuswrapElem.offset().top;
    let contactusTriggerPos = contactuswrapTop - winIH;
  
    //ウィンドウサイズにより、縮小スピードを変える(数値が小さいほど速く縮小拡大し、数値が大きいほどゆっくり縮小拡大する)
    if (winIW < 480) {
      contactusScaleSpeed = 0.0015;
    } else if (winIW < 768) {
      contactusScaleSpeed = 0.0014;
    } else if (winIW < 1080) {
      contactusScaleSpeed = 0.0013;
    } else if (winIW < 1320) {
      contactusScaleSpeed = 0.0012;
    } else if (winIW < 1520) {
      contactusScaleSpeed = 0.0011;
    } else if (winIW < 1920) {
      contactusScaleSpeed = 0.0010;
    } else if (winIW < 2220) {
      contactusScaleSpeed = 0.0009;
    } else {
      contactusScaleSpeed = 0.0008;
    }
  
    if ( scroll >= contactusTriggerPos ) {
      contactusTranslateYTemp = contactusTranslateY - ( ( scroll - contactusTriggerPos ) * (contactusScaleSpeed * 50));
      contactusZoomSizeTemp = contactusZoomSize - ( ( scroll - contactusTriggerPos ) * contactusScaleSpeed);
      
      if (contactusTranslateYTemp <= 0) {
        contactusTranslateYTemp = 0;
      }
      if (contactusZoomSizeTemp <= 1) {
        contactusZoomSizeTemp = 1;
      }
  
      contactusElem.css({transform: 'translate(0, ' + contactusTranslateYTemp  + '%) scale(' + contactusZoomSizeTemp  + ')'});
    } else {
      contactusElem.css({transform: 'translate(0, ' + contactusTranslateY  + '%) scale(' + contactusZoomSize  + ')'});
    }
  }


  // footerがある場合
  if ( $('#footer').length ) {
    let magni = 1.5;  //倍率(横長画面時に、ページ下端までスクロールした時に等倍への縮小が終わるような値に調整する)
    let footerScaleSpeed = 0.0015;
    let footerwrapElem  = $('#footerwrap');
    let footerElem  = $('#footer');
    let footerH = footerElem.height(); //footerタグの中身の高さ

    ///// Contact Us縮小拡大 /////
    let footerZoomSize = 1.5;
    let footerTranslateY = 25; //25%パーセント
    let footerwrapTop = footerwrapElem.offset().top;
    let footerTriggerPos = footerwrapTop - winIH;
    
    //ウィンドウの縦横比率により、縮小拡大・スライドアップダウンのスピードの倍率を変える
    if ( winIW / winIH <= 5 ) {
      magni = 1.5;
    } else if ( winIW / winIH <= 5 ) {
      magni = 1.75;
    } else {
      magni = 2;
    }
  
    //ウィンドウサイズにより、縮小スピードを変える(数値が小さいほど速く縮小拡大し、数値が大きいほどゆっくり縮小拡大する)
    if (winIW < 480) {
      footerScaleSpeed = 0.0015 * magni;
    } else if (winIW < 768) {
      footerScaleSpeed = 0.0014 * magni;
    } else if (winIW < 1080) {
      footerScaleSpeed = 0.0013 * magni;
    } else if (winIW < 1320) {
      footerScaleSpeed = 0.0012 * magni;
    } else if (winIW < 1520) {
      footerScaleSpeed = 0.0011 * magni;
    } else if (winIW < 1920) {
      footerScaleSpeed = 0.0010 * magni;
    } else if (winIW < 2220) {
      footerScaleSpeed = 0.0009 * magni;
    } else {
      footerScaleSpeed = 0.0008 * magni;
    }
  
    if ( scroll >= footerTriggerPos ) {
      footerTranslateYTemp = footerTranslateY - ( ( scroll - footerTriggerPos ) * (footerScaleSpeed * 50) * magni);
      footerZoomSizeTemp = footerZoomSize - ( ( scroll - footerTriggerPos ) * footerScaleSpeed * magni);
      
      if (footerTranslateYTemp <= 0) {
        footerTranslateYTemp = 0;
      }
      if (footerZoomSizeTemp <= 1) {
        footerZoomSizeTemp = 1;
      }
  
      footerElem.css({transform: 'translate(0, ' + footerTranslateYTemp  + '%) scale(' + footerZoomSizeTemp  + ')'});
    } else {
      footerElem.css({transform: 'translate(0, ' + footerTranslateY  + '%) scale(' + footerZoomSize  + ')'});
    }


/*
    // スライドアップのみする場合
    let footerElem  = $('#footer');
    let footerH = footerElem.height(); //footerタグの中身の高さ
    let footerTop = footerElem.offset().top;
    let footerTriggerPos =  footerTop - (winIH * 0.8);  // footerが画面の上から80%(下から20%)に来た時に動く(この数値を小さくし過ぎると、画面サイズが大きい場合、トリガー位置まで画面がスクロールできず、スライドアップしないので注意)
    
    if ( scroll >= footerTriggerPos ) {
      footerElem.attr('data-scroll', 'true');
    } else {
      footerElem.attr('data-scroll', 'false');
    }
*/
  }
});



//fadein
$(window).scroll(function (){
  $('.js-fadeIn').each(function(){
    var elemPos = $(this).offset().top;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll > elemPos - windowHeight - 30){
        $(this).addClass('js-scrollIn');
    }
  });
});


// 電話番号リンク
if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
  $(function() {
    $('.js-tellink').each(function() {
      var str = $(this).html();

      if ($(this).children().is('img')) {
        $(this).html($('<a>').attr('href', 'tel:' + $(this).children().attr('alt').replace(/[^0-9]/g, '')).append(str + '</a>')); //対象文字列内から数字だけ取り出してhrefにセット
      } else {
        $(this).html($('<a>').attr('href', 'tel:' + $(this).text().replace(/[^0-9]/g, '')).append(str + '</a>')); //対象文字列内から数字だけ取り出してhrefにセット
      }
    });
  });
}
